module.exports = __webpack_public_path__ + "static/media/wrap3.4d53e951.jpg";